import React, { createContext, useContext } from 'react';
import {
  IProviderProps,
  ISelectedDoor,
  ISelectedElement, ISelectedHotspot, ISelectedModel2D,
  ISelectedPassage,
  ISelectedProduct,
  ISelectedRadiator,
  ISelectedSimpleMeasurement,
  ISelectedSpace,
  ISelectedWall,
  ISelectedWindow,
  ISelectionHandlers
} from '../@types/ContextProviderRelated';
import { EActiveDrawer, EDirection } from '../@types/Enums';
import { useSelectionHandlers } from '../hooks/useSelectionHandlers';

const selectionContextDefaultValues: ISelectionHandlers = {
  selectedStandardWall: {} as ISelectedWall,
  selectedPartitionWall: {} as ISelectedWall,
  selectedSpace: {} as ISelectedSpace,
  selectedWindow: {} as ISelectedWindow,
  selectedDoor: {} as ISelectedDoor,
  selectedPassage: {} as ISelectedPassage,
    selectedModel2D: {} as ISelectedModel2D,
    selectedHotspot: {} as ISelectedHotspot,
  selectionAllowed: false,
  selectedSimpleMeasurement: {} as ISelectedSimpleMeasurement,
  selectedProduct: {} as ISelectedProduct,
  selectedRadiator: {} as ISelectedRadiator,
  selectedElement: {} as ISelectedElement,
  setSelectionAllowed: () => {},
  handleWallClick: () => {},
  handleSpaceClick: () => {},
  handleWindowClick: () => {},
  handleDoorClick: () => {},
  handlePassageClick: () => {},
    handleModel2DClick: () => { },
    handleHotspotClick: () => { },
  handleSimpleMeasurementClick: () => {},
  handleProductClick: () => {},
  handleRadiatorClick: () => {},
  handleElementClick: () => {},
  activeDrawer: EActiveDrawer.NONE,
  setActiveDrawer: () => {},
  resetSelection: () => {},
  resetSelectionWithoutHistoryDrawer: () => {},
  hasSelection: () => false,
  hasSelectionWithoutDrawer: () => false,
  handlePartitionWallClick: (_wallIndex: number) => {},
  wallChangeDirection: EDirection.BOTH,
  setWallChangeDirection: () => {},
  wallThicknessDirection: EDirection.LEFT,
  setWallThicknessDirection: () => {},
};

const SelectionContext = createContext<ISelectionHandlers>(selectionContextDefaultValues);

export const useSelection = () => useContext<ISelectionHandlers>(SelectionContext);

export const SelectionProvider = ({ children }: IProviderProps): JSX.Element => {
  const selectionHandlers: ISelectionHandlers = useSelectionHandlers();

  return <SelectionContext.Provider value={selectionHandlers}>{children}</SelectionContext.Provider>;
};
